export default "//yastatic.net/s3/distribution/pythia/frontend/_/619f0df696b477fe4ee82e56f8903355.svg";